<template>
    <h1>{{ resolvedQuestionaireTypeTitle }}</h1>
    <AssessmentQuestionaireForm
        :assessment-id="assessmentId"
        :assessment-type="assessmentType"
        standalone
    />
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AssessmentQuestionaireForm from '../../../components/assessments/questionaires/AssessmentQuestionaireForm.vue';

const route = useRoute();
const assessmentType = computed(() => route.params.type ?? null)
const assessmentId = computed(() => route.params.id ?? null)


const resolvedQuestionaireTypeTitle = computed(() => {
    let title;
    switch (assessmentType.value) {
        case "self":
            title =  `Auto-avaliação`;
			break;
        case "ascending":
            title =  "Avaliação Ascendente";
			break;
        case "downward":
            title =  "Avaliação Descendente";
			break;
    
        default:
            throw new RangeError("Invalid value for 'assessmentType' property!");
    }
    
    return title;
});
</script>